<template>
	<div class="bg">
		<im-nav></im-nav>
		<div style="width: 80%;">
			<el-tabs :tab-position="tabPosition">
				<el-tab-pane label="海迅IM介绍" >
					<div>
						<p class="title">海讯IM介绍</p>
						<p>海讯IM，轻量级人工智能IM解决方案供应商。</p>
						<p>海讯IM（https://hisay.im）作为浪鲸智能旗下即时通讯云PaaS平台核心产品，采用高可用的平台架构，满足多场景企业内外部实时通讯需求，兼容服务器端集成和客户端集成，真正做到安全、即时、高效，拥有卓越的可拓展性，提供人工智能技术赋能和安全保障，海讯IM以其强大的智能技术日趋成为AI+IM的智能时代卓越典范。</p>
					</div>
				</el-tab-pane>
				<el-tab-pane label="海迅IM架构">
					<div class="box">
						<p class="title">海讯IM的架构原则</p>
						<p>（1）代码可复用性（对接多套系统）；</p>
						<p>（2）服务高可用性（主从式部署）；
							<p>（3）服务高并发性能（分布式部署）；</p>
							<p>（4）可拓展性（兼容多消息类型）；</p>
							<p>（5）数据安全（客户服务器可选择性存储用户消息记录）。</p>
							<p class="title">海讯IM的架构图解</p>
							<p>（1）模式一：服务器端集成能力收发消息架构（由服务器负责推送和处理消息）：</p>
							<img src="../../public/img/docu/d1.png" />
							<p>（2）模式二：客户端集成能力收发消息架构（由客户端负责推送和处理消息）：</p>
							<img src="../../public/img/docu/d2.png" />
					</div>
				</el-tab-pane>
				<el-tab-pane label="海迅IM新手指引">
					<div class="box">
						<p class="title">1.3.1 申请APPID和APPTOKEN</p>
						<p>海讯IM内测阶段请开发者联系admin@yofea.com或者致电4006969956，以获得APPID和APPTOKEN及其相关帮助。</p>
						<p class="title">1.3.2 配置消息回调等URL</p>
						<p>如果您采用服务器端集成能力架构（模式一），您可下载并使用我们为您提供的后端SDK或者直接参见服务器端集成接口文档调用接口，从而方便快捷地使用我们的IM服务；</p>
						<p>如果您采用客户端集成能力架构（模式二），且您有在您自身的业务服务器中持久化消息的需求，那么您可登录后使用可视化的控制台配置您的消息回调地址和鉴权回调地址，配置回调URL后，您可参见文档或DEMO进行接口编写以处理海讯IM请求您所配置的URL事件。并且根据您的情况在后台设置应用状态（“禁用”、“启用并启用回调”或“启用并禁用回调”）。
						</p>
						<p>至此，您就可参阅接口文档进行调用和集成开发啦！</p>

						<p class="title">1.3.3 鉴权及回调指引</p>
						<p>（1）鉴权验证图示</p>
						<img src="../../public/img/docu/d3.png" />
						<p class="title">（2）鉴权回调的配置与处理</p>
						<p>客户端、客户业务服务器、海讯IM服务器间的鉴权回调的配置与处理可参阅上述鉴权验证图示：</p>
						<p>①客户端访问您的业务服务器由您自主定义鉴权验证规则；</p>
						<p>②客户端请求即时通讯服务器采用OAuth2.0鉴权机制，请求相关API需带上OAuthToken，其生成规则为md5(uid+appid+token)，其中，token为开发者自主为每个用户在一定规则下生成的认证字符串。若开发者采用的是客户端集成架构（模式一），且开发者没有配置拉取某个特定用户uid对应的token的回调接口，则海讯IM将默认使用AppToken作为此处的token参数来配合生成客户端访问海讯IM服务器所需的OAuthToken。如果开发者配置了拉取特定用户uid对应的token的回调接口，海讯IM将在客户端提交接口请求时向客户业务服务器拉取一次OAuthToken与客户端传输的此参数进行核对，OAuthToken匹配则放行，不匹配的客户端请求将被丢弃；</p>
						<p>③海讯IM服务器请求客户业务服务器，除消息相关参数外，还会带上sign参数（或在请求头中设置Sign参数）和timestamp参数一并请求开发者的业务服务器，开发者可在配置的业务服务器的相关接口处进行相应验证和处理。其中sign参数生成规则为：md5(appid+timestamp+apptoken)，timestamp由海讯IM服务器生成，请求时和消息相关参数一并发送给客户业务服务器；</p>
						<p>④客户业务服务器请求海讯IM服务器，要想成功调用推送消息等接口，也需带上sign参数或者在请求头中添加Sign参数键值作为AppTokenSign签名参与验证，签名生成规则为：md5(appid+timestamp+md5(apptoken))，timestamp参数由开发者自主生成并随请求一并提交至海讯IM服务器相关接口，海讯IM除核验sign参数值是否匹配外，也将核验此时间戳是否小于当前时间60秒以上，是则视为超时请求不予放行，否则正常访问海讯IM相关接口，如您使用了海讯的后端SDK，可不比关心该sign值以及timestamp参数的生成和携带，我们已为您封装携带完毕，您只需传输必要参数即可完成API请求调用。</p>
					</div>
				</el-tab-pane>
				<el-tab-pane label="sdk下载及使用">
					<p class="title"> 集成SDK下载及使用</p>
					<p>PHP集成SDK下载</p>
					<p>PHP集成SDK接口文档下载</p>
					<p>PHP集成和处理回调示例DEMO下载</p>
				</el-tab-pane>
				<el-tab-pane label="客户端调用接口">
					<div class="box">
						<clienttable></clienttable>
					</div>
				</el-tab-pane>
				<el-tab-pane label="服务端调用接口">
					<div class="box">
						<servetable></servetable>
					</div>
				</el-tab-pane>
				<el-tab-pane label="服务端帮助文档">
					<div class="box">
						<servehelptable></servehelptable>
					</div>
				</el-tab-pane>
			</el-tabs>
		</div>
		<mybottom></mybottom>
	</div>
</template>

<script>
	import imNav from "../components/nav.vue"
	import clienttable from "../components/client-table.vue"
	import servetable from "../components/serve-table.vue"
	import servehelptable from "../components/servehelp-table.vue"
	import mybottom from "../components/mybottom.vue"
	export default {
		components: {
			imNav,
			clienttable,
			servetable,
			servehelptable,
			mybottom
		},
		data() {
			return {
				tabPosition: 'left'
			};
		}
	};
</script>
<style>
	.bg {
		width: 100vw;
		height: 100vh;
		background-color: white;
		position: relative;
		display: flex;
		align-items: center;
		flex-direction: column;
	}

	.box {
		height: 82vh;
		overflow: scroll;
		overflow-x: hidden;
	}

	.title {
		font-size: 20px;
		font-weight: 600;
	}

	p {
		width: 80%;
	}
</style>
